import SelectKeys from '../../../constants-v2/state/select-keys';
import column from '../../abstract/column';
import vars from '../../abstract/vars';
import api, { modelName } from './api';


const CURRENT_DATE = new Date();

function y(minusYears = 0) {
  return CURRENT_DATE.getFullYear() - minusYears;
}

function hasPriceIncreaseExistForYear(item, year) {
  const el = item?.agreementpriceincrease.filter(item => {
    const effectiveFrom = item?.effective_from;
    if (!effectiveFrom) {
      return false;
    }

    const effectiveFromDate = new Date(effectiveFrom);
    return year === effectiveFromDate.getFullYear();
  });

  if (!el.length) {
    return false;
  }

  return true;
}

function hasPriceIncreaseNotAppliedForYear(item, year) {
  const el = item?.agreementpriceincrease.filter(item => {
    const effectiveFrom = item?.effective_from;
    if (!effectiveFrom) {
      return false;
    }

    const effectiveFromDate = new Date(effectiveFrom);
    if (year !== effectiveFromDate.getFullYear()) {
      return false;
    }

    return !item?.applied;
  });

  if (!el.length) {
    return false;
  }

  return true;
}

function getIconColor(item, year) {
  if (!hasPriceIncreaseExistForYear(item, year)) {
    return 'grey';
  }

  if (hasPriceIncreaseNotAppliedForYear(item, year)) {
    return 'warning';
  }

  return 'success';
}

function getIconType(item, year) {
  if (!hasPriceIncreaseExistForYear(item, year)) {
    return 'block';
  }

  return 'check';
}

function getTooltipText(item, year) {
  if (!hasPriceIncreaseExistForYear(item, year)) {
    return 'Brak indeksacji cen.';
  }

  if (hasPriceIncreaseNotAppliedForYear(item, year)) {
    return 'Indeksacja cen oczekuje na wykonanie.';
  }

  return 'Indeksacja cen została już wykonana.';
}

export default {
  actions: {},
  topRightActions: {},
  api,
  modelName,
  sidebarData: {
    id: column({
      label: 'Identyfikator',
      size: 100
    }),
  },
  columns: {
    selected: column({
      label: '#',
      component: 'value-select',
      selectable: true,
      sidebar: false,
      selectKey: SelectKeys.AGREEMENT_PRICE_INCREASE,
    }),
    number: column({
      label: 'Numer umowy',
      format: item => item?.number?.number,
    }),
    crm: column({ label: 'Kontrahent', format: item => item?.crm?.client?.person?.company?.name }),
    status: column({
      label: 'Status',
      component: 'value-agreement-signing-date-info-chip',
      custom: ({ item }) => {
        return {
          item,
        };
      },
    }),

    conclusion_date: column({ label: 'Rozpoczęcie', format: item => item?.conclusion_date }),
    is_annex: column({ label: 'Aneks', format: item => item?.is_annex ? 'Tak' : 'Nie' }),

    year: column({
      label: y(),
      component: 'ValueIconTooltip',
      iconTooltipConfig: () => {
        const year = y();
        return {
          icon: (item) => getIconType(item, year),
          tooltip: (item) => getTooltipText(item, year),
          iconColor: (item) => getIconColor(item, year),
        };
      },
    }),

    year2: column({
      label: y(1),
      component: 'ValueIconTooltip',
      iconTooltipConfig: () => {
        const year = y(1);
        return {
          icon: (item) => getIconType(item, year),
          tooltip: (item) => getTooltipText(item, year),
          iconColor: (item) => getIconColor(item, year),
        };
      },
    }),

    year3: column({
      label: y(2),
      component: 'ValueIconTooltip',
      iconTooltipConfig: () => {
        const year = y(2);
        return {
          icon: (item) => getIconType(item, year),
          tooltip: (item) => getTooltipText(item, year),
          iconColor: (item) => getIconColor(item, year),
        };
      },
    }),
  },
  vars: vars({
    noItemsText: 'Brak umów',
    sidebarLabel: 'Podgląd umowy',
  }),
};
